import { render, staticRenderFns } from "./LivestreamInteractionItem.vue?vue&type=template&id=6189003d&scoped=true&"
import script from "./LivestreamInteractionItem.vue?vue&type=script&lang=js&"
export * from "./LivestreamInteractionItem.vue?vue&type=script&lang=js&"
import style0 from "./LivestreamInteractionItem.vue?vue&type=style&index=0&id=6189003d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6189003d",
  null
  
)

export default component.exports